<template>
  <div class="IndexSwiper_div_warp">
    <div class="swiper-container" id="IndexSwipers" v-if="bannerList.length > 0">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <img v-lazy="item.adurl" alt="swiper">
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
  <!-- end 轮播图 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getAdConfig} from 'api/systemApi'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.min.css'

export default {
  name: 'IndexSwiper',
  data () {
    return {
      bannerList: []  // 广告列表
    }
  },
  mounted () {
    this.getBannerList()
  },
  methods: {
    getBannerList() {
      this.setLoading(true)
        getAdConfig({
          data: {
            adcode: 'N09'
          },
          success: data => {
            this.setLoading(false)
            this.bannerList = data.data.content
            this.$nextTick(() => {
              this.initSwiper()
            })
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      initSwiper() {
        new Swiper('#IndexSwipers', {
          autoplay: {
            delay: 3000,//3秒切换一次
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
        })
      },
       ...mapActions([
            'setLoading'
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      
  }
}
</script>
<style lang="scss" type="text/scss">
.IndexSwiper_div_warp {
  margin-left: 407px;
  // float: right;
  width:794px;
  height:352px;
  background: #ccc;
  .swiper-pagination-bullet {
      background: #C8C2DE;
      width: 6px;
      height: 6px;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      width: 22px;
      height: 6px;
      border-radius:4px;
    }
  .swiper-slide {
    img {
      width: 100%;
      height: 352px;
    }
  }
}
</style>
